import React from 'react';

export default function Disclaimer() {
  return (
    <div className="bg-white min-h-screen flex flex-col py-10 px-2">
      <div className="max-w-3xl mx-auto bg-white rounded-xl shadow-xl border border-gray-200 p-8">
        <h1 className="text-3xl text-center font-bold text-purple-600 mb-6">
          Disclaimer
        </h1>

        <div className="space-y-8">
          {/* General */}
          <div>
            <h2 className="text-xl text-blue-900 font-semibold mb-3">
              General Information
            </h2>
            <p className="text-gray-700">
              The content and services provided through Million2Trillion (M2T)
              are intended for informational, networking, and educational
              purposes only. While we strive to maintain accurate and updated
              information, we do not warrant the completeness, reliability, or
              accuracy of any content published on the platform.
            </p>
          </div>

          {/* Financial Advice */}
          <div>
            <h2 className="text-xl text-blue-900 font-semibold mb-3">
              No Financial or Investment Advice
            </h2>
            <p className="text-gray-700">
              Million2Trillion does not provide direct trading, investment,
              brokerage, or financial advisory services. Nothing on this
              platform constitutes financial, legal, or tax advice. Users are
              encouraged to consult licensed professionals before making any
              financial or business decisions.
            </p>
          </div>

          {/* User Content */}
          <div>
            <h2 className="text-xl text-blue-900 font-semibold mb-3">
              User-Generated and Third-Party Content
            </h2>
            <p className="text-gray-700">
              Any opinions, insights, or materials shared by users, mentors,
              analysts, or third-party providers reflect their own perspectives
              and do not represent the views of Million2Trillion. M2T does not
              verify or guarantee the accuracy or results of user-shared
              content, products, or services.
            </p>
          </div>

          {/* Platform Role */}
          <div>
            <h2 className="text-xl text-blue-900 font-semibold mb-3">
              Platform Role
            </h2>
            <p className="text-gray-700">
              Million2Trillion operates solely as a global network that connects
              verified users and businesses through a secure gateway. All users
              and organizations remain independently responsible for their own
              actions, compliance, and engagements conducted through the
              platform.
            </p>
          </div>

          {/* Risk Awareness */}
          <div>
            <h2 className="text-xl text-blue-900 font-semibold mb-3">
              Risk Awareness
            </h2>
            <p className="text-gray-700">
              Interacting within financial or business markets may involve
              inherent risks. Million2Trillion does not guarantee profitability,
              performance, or success resulting from any connection or
              collaboration formed via the platform.
            </p>
          </div>

          <p className="mt-8 text-sm text-center text-gray-500 italic">
            Last updated: October 2025
          </p>
        </div>
      </div>
    </div>
  );
}
